import { Col, Row } from "antd";
import { useTranslation } from "react-i18next";
import Navbar from "../Menu/Navbar";
import Footer from "./Sections/Footer";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../apis/store";
import { useEffect } from "react";
import { toGetLoyaltyProgramDetails } from "../../apis/actions/loyaltyProgramDetails.actions";
import parse from "html-react-parser";
import { Link } from "react-router-dom";
import { useLoyaltyContent } from "./Sections/LoayalityProgram";
import { sectionText } from "./Sections/useSectionData";
import PageBannerLoading from "../../Components/layouts/PageBannerLoading";

const LoyaltyProgramInternal = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { t, i18n } = useTranslation();
  const { list } = useSelector(
    (state: RootState) => state.program.loyaltyProgramDetails
  );
  const {
    section,
    loading,
    eyebrow,
    ctaLabel,
    ctaUrl,
    items,
    lines,
    images: apiImages,
  } = useLoyaltyContent();
  useEffect(() => {
    dispatch(toGetLoyaltyProgramDetails(i18n.language));
  }, [dispatch]);

  // The last slot keeps the loyalty-program record image when the API sends none.
  const images = [1, 2, 3, 4, 5]
    .map((n) => `assets/imgs/cta/cta-3/img-${n}.png`)
    .concat(list[0]?.image_1920)
    .map((src, i) => apiImages[i] ?? src);
  const ctaClass =
    "btn btn-signin mb-4 wow fadeInDown ac--loyalty-program-cta";

  if (loading) return <PageBannerLoading />;

  return (
    <>
      <Navbar type="internal" />
      <section className="background-body">
        <div className=" box-cta-3 p-40 ac--background-loyalty-program-internal  ac--font-expo  mx-auto position-relative overflow-hidden">
          <div className="container">
            <Row className="align-items-center pt-20">
              <Col xxl={12} xl={12} md={12} lg={12} sm={24} xs={24}>
                <h3 className="heading-3 mb-2 neutral-1000 wow fadeInUp ac--color-primary ac--font-expo">
                  {sectionText(section?.title) ?? list[0]?.name}
                </h3>

                <span className=" bg-white text-dark mb-4 wow fadeInDown ac--btn-white ac--loyality-text">
                  {eyebrow}
                </span>
                {lines.length ? (
                  lines.map((line, index) => (
                    <p key={`${line}-${index}`}>
                      <h6 className="mb-4 pe-lg-1 mt-20 neutral-1000 wow fadeInUp ac--color-primary ac--font-expo">
                        {line}
                      </h6>
                    </p>
                  ))
                ) : (
                  <>
                    <p>
                      <h6 className="mb-4 pe-lg-1 mt-20 neutral-1000 wow fadeInUp ac--color-primary ac--font-expo">
                        {list[0]?.summary && parse(list[0]?.summary)}
                      </h6>
                    </p>
                    <p>
                      <h6 className="mb-4 pe-lg-1 neutral-1000 wow fadeInUp ac--color-primary ac--font-expo">
                        {t("home.loyality.description2")}
                      </h6>
                    </p>
                  </>
                )}
                <div className="row">
                  <div className="col">
                    <ul
                      className="list-ticks-green"
                      style={{ display: "block" }}
                    >
                      {items.map((item, index) => (
                        <li
                          key={`${item}-${index}`}
                          className="neutral-1000 ac--font-expo wow fadeInUp ac--color-primary"
                        >
                          <h6>{item}</h6>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                {/* The page would otherwise link to itself, so without a
                    button_url the label stays a plain badge. */}
                {!sectionText(section?.button_url) ? (
                  <span className={ctaClass}>{ctaLabel}</span>
                ) : /^https?:\/\//i.test(ctaUrl) ? (
                  <a
                    href={ctaUrl}
                    className={ctaClass}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {ctaLabel}
                  </a>
                ) : (
                  <Link to={ctaUrl} className={ctaClass}>
                    {ctaLabel}
                  </Link>
                )}
              </Col>
              <Col
                xxl={12}
                xl={12}
                md={12}
                lg={12}
                sm={24}
                xs={24}
                className="position-relative z-1 mt-lg-0 mt-4"
              >
                <div className="box-image-payment-2 ac--loyalty-program-images">
                  <Row className=" align-items-center" gutter={16}>
                    <Col
                      xxl={8}
                      xl={8}
                      lg={8}
                      md={8}
                      xs={8}
                      sm={8}
                      className=" mb-30"
                    >
                      <img
                        className="bdrd8 w-100 wow fadeIn"
                        data-wow-delay="0.1s"
                        src={images[0]}
                        alt=""
                      />
                    </Col>
                    <Col
                      xxl={8}
                      xl={8}
                      lg={8}
                      md={8}
                      xs={8}
                      sm={8}
                      className=" mb-30"
                    >
                      <img
                        className="bdrd8 w-100 mb-15 wow fadeIn"
                        data-wow-delay="0.2s"
                        src={images[1]}
                        alt=""
                      />
                      <img
                        className="bdrd8 w-100 wow fadeIn"
                        data-wow-delay="0.3s"
                        src={images[2]}
                        alt=""
                      />
                    </Col>
                    <Col
                      xxl={8}
                      xl={8}
                      lg={8}
                      md={8}
                      xs={8}
                      sm={8}
                      className=" mb-30"
                    >
                      <img
                        className="bdrd8 w-100 mb-15 wow fadeIn"
                        data-wow-delay="0.4s"
                        src={images[3]}
                        alt=""
                      />
                      <img
                        className="bdrd8 w-100 wow fadeIn"
                        data-wow-delay="0.5s"
                        src={images[4]}
                        alt=""
                      />
                      <img
                      style={{marginTop:"2rem"}}
                        className="bdrd8 w-100 wow fadeIn"
                        data-wow-delay="0.5s"
                        src={images[5]}
                        alt=""
                      />
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </div>
          <div className="bg-overlay position-absolute bottom-0 end-0 h-75 background-brand-2 opacity-25 z-0 rounded-start-pill"></div>
        </div>
      </section>
      <Footer type="external" />
    </>
  );
};

export default LoyaltyProgramInternal;
